import {
  animate,
  AUTO_STYLE,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  input,
  output,
  signal,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TypedTemplateDirective } from '@boels/helpers';
import { BoelsPointOfServiceStock } from '@boels/models';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {
  faCaretDown,
  faCaretUp,
  faChevronRight,
} from '@fortawesome/free-solid-svg-icons';
import { TRANSLOCO_SCOPE, TranslocoModule } from '@jsverse/transloco';
import { ButtonComponent } from '../../../button/button.component';

@Component({
  selector: 'boels-point-of-service-card',
  templateUrl: './point-of-service-card.component.html',
  styleUrls: ['./point-of-service-card.component.scss'],
  imports: [
    CommonModule,
    FontAwesomeModule,
    TranslocoModule,
    FormsModule,
    TypedTemplateDirective,
    ButtonComponent,
  ],
  providers: [
    {
      provide: TRANSLOCO_SCOPE,
      useValue: ['checkout', 'storeFinder'],
    },
  ],
  animations: [
    trigger('collapse', [
      state('false', style({ height: AUTO_STYLE, visibility: AUTO_STYLE })),
      state('true', style({ height: '0', visibility: 'hidden' })),
      transition('false => true', animate(250 + 'ms ease-in')),
      transition('true => false', animate(250 + 'ms ease-out')),
    ]),
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PointOfServiceCardComponent {
  $pointOfService = input.required<BoelsPointOfServiceStock>();
  $isActive = input.required<boolean>();
  $dayOfTheWeek = input.required<string>();

  @HostBinding('class') get classes() {
    return this.$isActive() ? '-selected' : '';
  }

  $isInnerExpanded = signal<boolean>(false);

  pointOfServiceSelected = output();

  protected readonly faCaretDown = faCaretDown;
  protected readonly faCaretUp = faCaretUp;
  protected readonly faCaretRight = faChevronRight;
}
